<template>
    <v-sheet>
        <resume-personal-information v-model="form.resume" @input="emit" />
        <resume-name v-model="form.resume" class="mt-40 mt-lg-60" @input="emit" />
        <resume-education v-model="form.resume" class="mt-40 mt-lg-60" @input="emit" />
        <resume-work-experience v-model="form.resume" class="mt-40 mt-lg-60" @input="emit" />
        <resume-hash-tags v-model="form.resume" v-bind="{ hashTags }" class="mt-40 mt-lg-60" @input="emit" />
        <resume-languages v-model="form.resume" class="mt-40 mt-lg-60" @input="emit" />
        <resume-office-skills v-model="form.resume" class="mt-40 mt-lg-60" @input="emit" />
        <resume-certifications v-model="form.resume" class="mt-40 mt-lg-60" @input="emit" />
        <resume-cover-letter v-model="form.resume" class="mt-40 mt-lg-60" @input="emit" />
        <div class="v-btn-group">
            <v-btn v-bind="{ loading }" outlined color="grey-d" class="min-w-140px min-w-lg-160px" @click="save()"><span class="grey-6--text">임시저장</span></v-btn>
            <v-btn v-bind="{ loading }" color="primary" class="min-w-140px min-w-lg-160px" @click="save(MICEPEC_RECORDS.value)"><span>저장 후 다음으로</span></v-btn>
        </div>
    </v-sheet>
</template>

<script>
import api from "@/api";
import { APPLICATION_STATES, APPLICATION_WRITIG_STEPS, initApplication, USER_FILE_TYPES } from "@/assets/variables";

import ResumeName from "@/components/client/resume/resume-name.vue";
import ResumeHashTags from "@/components/client/resume/resume-hash-tags.vue";
import ResumeEducation from "@/components/client/resume/resume-education.vue";
import ResumeLanguages from "@/components/client/resume/resume-languages.vue";
import ResumeCoverLetter from "@/components/client/resume/resume-cover-letter.vue";
import ResumeOfficeSkills from "@/components/client/resume/resume-office-skills.vue";
import ResumeCertifications from "@/components/client/resume/resume-certifications.vue";
import ResumeWorkExperience from "@/components/client/resume/resume-work-experience.vue";
import ResumePersonalInformation from "@/components/client/resume/resume-personal-information.vue";

const state = APPLICATION_STATES.ON_WRITING.value;
const { RESUME, MICEPEC_RECORDS } = APPLICATION_WRITIG_STEPS;

export default {
    components: {
        ResumeName,
        ResumeHashTags,
        ResumeEducation,
        ResumeLanguages,
        ResumeCoverLetter,
        ResumeOfficeSkills,
        ResumeCertifications,
        ResumeWorkExperience,
        ResumePersonalInformation,
    },
    props: {
        value: { type: Object, default: () => ({}) }, // form
        hashTags: { type: Array, default: () => [] },
        loading: { type: Boolean, default: false },
    },
    data: () => ({
        form: initApplication(),

        MICEPEC_RECORDS,
    }),
    computed: {
        isCreate() {
            return !this.value?._id;
        },
    },
    mounted() {
        this.sync();
    },
    watch: {
        value() {
            this.sync();
        },
    },
    methods: {
        sync() {
            this.form = initApplication(this.value);
        },
        emit() {
            this.$emit("input", this.form);
        },
        validate() {
            /** @type {import("@/plugins/vue-validate").Criterion[]} */
            let criteria = [
                {
                    key: "personalInformation.name",
                    message: "이름을 입력하세요",
                },
                {
                    key: "personalInformation.bornAt",
                    message: "생년월일을 입력하세요",
                },
                {
                    key: "personalInformation.gender",
                    message: "성별을 입력하세요",
                },
                {
                    key: "personalInformation.phone",
                    message: "연락처를 입력하세요",
                },
                {
                    key: "personalInformation.email",
                    message: "이메일을 입력하세요",
                },
                {
                    key: "personalInformation.residence.postcode",
                    message: "우편번호를 입력하세요",
                },
                {
                    key: "personalInformation.residence.address1",
                    message: "기본주소를 입력하세요",
                },
                {
                    key: "personalInformation.residence.address2",
                    message: "상세주소를 입력하세요",
                },
                {
                    key: "name",
                    message: "이력서 제목을 입력하세요",
                },
            ];
            return this.$validate(this.form.resume, criteria);
        },
        async save(writingStep = RESUME.value) {
            if (!this.validate()) return;

            if (this.loading) return;
            else this.$emit("setLoading", true);

            try {
                let { ...form } = this.form;

                let { profile, ...resume } = form.resume || {};
                if (profile instanceof File) {
                    profile = (await api.v1.me.files.post({ type: USER_FILE_TYPES.PROFILE.value }, profile))?.file;
                }
                resume._profile = profile?._id;
                form.resume = resume;
                form.state = state;
                form.writingStep = writingStep;

                let { post, put } = api.v1.recruitments.application;
                const { application } = await (this.isCreate ? post : put)(form);

                this.$emit("input", initApplication(application));
                alert("저장되었습니다");
                this.$emit("setLoading", false);
                this.$nextTick(() => {
                    if (writingStep != RESUME.value) this.$emit("next");
                });
            } finally {
                this.$emit("setLoading", false);
            }
        },
    },
};
</script>
